module.exports = __webpack_public_path__ + "img/no-avatar-2.a0989ef9.png";